import { useMutation } from "@tanstack/react-query"
import { resendPhoneOtp } from "@/api"

export const useResendPhoneOtp = () => {
  return useMutation({
    mutationFn: (params?: { channel?: "email", purpose?: "two_factor" }) => resendPhoneOtp(params),
  })
}
